import * as React from "react";
import { Input, InputGroup, InputGroupText, Label } from "reactstrap";
import "./SearchBox.css";

interface ISearchBoxProps {
  placeHolder: string;
  label?: string;
  icon?: React.ReactElement;
  value?: string | number;
  onChange?: (e: any) => void;
  numberOnly?: boolean;
  maxLength?: number;
}

const SearchBox: React.FunctionComponent<ISearchBoxProps> = (props) => {
  return (
    <div className="mb-2">
      {props.label && (
        <Label className="mb-1 text-start search-label text-muted">
          {props.label}
        </Label>
      )}
      <InputGroup className="input-group-parent">
        <Input
          type={props.numberOnly ? "number" : "text"}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeHolder}
          className="border-end-0 input-control form-control-search-box"
          maxLength={props.maxLength}
        />
        <InputGroupText>{props.icon}</InputGroupText>
      </InputGroup>
    </div>
  );
};

export default SearchBox;
